import * as React from 'react';
import { classes } from './CopyUrlButton.st.css';
import { Check, Link } from '@wix/wix-ui-icons-common/on-stage';
import { Toast, ToastSkin, ToastPlacement } from '../Toast';
import { GetButtonIconProps, RenderSuccessProps } from './types';

const renderSuccess = ({ mobile, successText }: RenderSuccessProps) => {
  if (mobile) {
    return (
      <Toast
        skin={ToastSkin.success}
        placement={ToastPlacement.bottomFullWidth}
        shouldAnimate
        isShown
      >
        <div className={classes.success}>
          <Check />
          <span className={classes.successText}>{successText}</span>
        </div>
      </Toast>
    );
  }
  return (
    <div className={classes.success}>
      <Check className={classes.checkIcon} />
      <span className={classes.successText}>{successText}</span>
    </div>
  );
};

export const getButtonIcon = ({
  mobile,
  successText,
  success,
  icon = <Link />,
}: GetButtonIconProps) => {
  if (success) {
    if (mobile) {
      return (
        <>
          {icon}
          {renderSuccess({ mobile, successText })}
        </>
      );
    } else {
      return renderSuccess({ mobile, successText });
    }
  }
  return icon;
};
